import { Box, ListItem, styled, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledListItemBase = styled(ListItem)(({ theme }) => ({
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderColor: theme.palette.grey[700],
  paddingBlock: theme.spacing(2),
}));

export const StyledListItem = (
  props: ComponentProps<typeof StyledListItemBase>
) => <StyledListItemBase disablePadding {...props} />;

export const StyledListItemContent = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const StyledTypographyBase = styled(Typography)({
  fontSize: 12,
  fontWeight: 700,
});

export const StyledTypography = (
  props: ComponentProps<typeof StyledTypographyBase>
) => <StyledTypographyBase variant="body1" {...props} />;
